<template>
  <!-- (A) 로그인 알림 팝업 -->
  <LoginAlertPopup v-if="modalType === 'LOGIN_REQUIRED'" @close="closeModal" />

  <!-- (C) 회원가입 팝업 -->
  <SignupPopup v-if="modalType === 'SIGNUP'" @close="closeModal" />

  <!-- (D) 비밀번호 찾기 팝업 -->
  <ResetPasswordPopup
    v-if="modalType === 'RESET_PASSWORD'"
    @close="closeModal"
  />

  <!-- (E) 장바구니 팝업 -->
  <GoodsCartPopup v-if="modalType === 'CART_POPUP'" @close="closeModal" />

  <!-- (F) 주소 추가/적용 팝업 -->
  <AddressPopup
    v-if="modalType === 'ADDRESS_POPUP'"
    @close="closeModal"
    @submitAddress="onSubmitAddress"
  />

  <!-- (G) 통화 충돌 팝업 -->
  <CurrencyConflictPopup
    v-if="modalType === 'CURRENCY_CONFLICT'"
    @close="closeModal"
  />

  <!-- (H) 글로벌 Notification -->
  <NotificationPopup
    v-if="alertStore.visible"
    :message="alertStore.message"
    :type="alertStore.type"
    @close="alertStore.closeAlert"
  />

  <!-- (I) 쿠폰 조회 팝업 -->
  <CouponPopup
    v-if="modalType === 'COUPON_POPUP'"
    @close="closeModal"
    @applyCoupon="handleCouponApplied"
  />
</template>

<script setup>
import { computed } from "vue";
import { useModalStore } from "@/store/modalStore";
import { useAlertsStore } from "@/store/notifications/useAlertsStore";
import { useAddressStore } from "@/store/addressStore";
import { useCouponStore } from "@/store/couponStore";

// 팝업 컴포넌트 import
import LoginAlertPopup from "@/components/popup/LoginAlertPopup.vue";
import SignupPopup from "@/components/popup/SignupPopup.vue";
import ResetPasswordPopup from "@/components/popup/ResetPasswordPopup.vue";
import GoodsCartPopup from "@/components/popup/GoodsCartPopup.vue";
import AddressPopup from "@/components/popup/AddressPopup.vue";
import CurrencyConflictPopup from "@/components/popup/CurrencyConflictPopup.vue";
import NotificationPopup from "@/components/popup/Notification.vue";
// 쿠폰 팝업
import CouponPopup from "@/components/popup/CouponPopup.vue";

/** Pinia 스토어 */
const modalStore = useModalStore();
const alertStore = useAlertsStore();

/** modalType을 computed로 감싸서 사용 (동적 팝업 표시) */
const modalType = computed(() => modalStore.modalType);

const emit = defineEmits(["applyCoupon"]);

/**
 * (F) 주소 팝업: 예시로 addressStore에 선택된 주소를 저장
 */
function onSubmitAddress(selectedAddress) {
  console.log("[ModalContainer] onSubmitAddress:", selectedAddress);

  const addressStore = useAddressStore();
  addressStore.setSelectedAddress(selectedAddress);

  // 팝업 닫기
  closeModal();
}

/**
 * 팝업에서 쿠폰 선택/적용 시 호출
 * (CouponPopup.vue에서 예: `this.$emit("applyCoupon", { ... })`로 전달)
 */
function handleCouponApplied(selectedCoupon) {
  console.log("[ModalContainer] 쿠폰 적용:", selectedCoupon);

  // (1) Pinia 스토어에 저장
  const couponStore = useCouponStore();
  couponStore.setSelectedCoupon(selectedCoupon);

  // (2) 모달 닫기
  closeModal();
}

/**
 * 팝업 닫기
 */
function closeModal() {
  modalStore.closeModal();
}
</script>
